import { useEffect } from 'react';

var useEffectOnce = function useEffectOnce(effect) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
};

export default useEffectOnce;
//# sourceMappingURL=use-effect-once.esm.js.map
